import { Phone, MessageSquare } from "lucide-react";
import { COMPANY } from "../data";

export const MobileCTA = ({ onQuote }) => (
  <div data-testid="mobile-sticky-cta" className="sm:hidden fixed bottom-0 inset-x-0 z-40 flex gap-2 border-t border-white/10 bg-[#0a0a0c]/95 backdrop-blur-xl p-3">
    <a
      href={`tel:${COMPANY.phoneIntl}`}
      data-testid="mobile-call-btn"
      className="flex flex-1 items-center justify-center gap-2 rounded-full border border-white/15 py-3 font-bold text-white"
    >
      <Phone className="h-4 w-4 text-[#f5641e]" /> Call
    </a>
    <button
      onClick={onQuote}
      data-testid="mobile-quote-btn"
      className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#f5641e] py-3 font-bold text-[#0a0a0c]"
    >
      <MessageSquare className="h-4 w-4" /> Get a Quote
    </button>
  </div>
);
